export enum GoogleMapsAddressComponentType {
  HOUSE_NUMBER = 'street_number',
  ROAD = 'route', // a street, road, avenue, etc.
  TOWN_OR_CITY = 'locality', // Typically represents a city or town.
  POSTAL_TOWN = 'postal_town',
  SUB_LOCALITY = 'administrative_area_level_3', // This often represents a neighborhood or similar division.
  SUB_LOC = 'sublocality',
  COUNTY_OR_DISTRICT = 'administrative_area_level_2', // This could be a county, district, or region in some countries.
  STATE_OR_PROVINCE = 'administrative_area_level_1', // a province or region.
  NATION = 'country',
  POSTAL_CODE = 'postal_code',
  POLITICAL_STRUCTURE = 'political', // Since "political" is quite generic, this name could vary.
}

export interface AddressValidationInput {
  values: Partial<Record<string, string>>;
  fieldMap: Partial<Record<string, GoogleMapsAddressComponentType[]>>;
}

export interface AddressValidationResult {
  userInputs?: AddressValidationInput;
  found: boolean;
  discrepancies?: Discrepancy | null;
  correctedAddressList?: Record<string, string>;
}

export interface Discrepancy {
  [key: string]: { expected: string; actual: string };
}
